import { useModuleData } from '@rebuild/hooks/data/useModuleData';

export const useInstitutionSuggestions = () => {
	const { message_subscription_institutionList } = useModuleData();

	const queryInstitutionList = async (queryString, cb) => {
		await message_subscription_institutionList.refresh({
			pagestart: 0,
			pagenum: 20,
			fullname: queryString || ''
		});
		cb(message_subscription_institutionList.data?.rows || []);
	};

	return {
		queryInstitutionList
	};
};
